<template>
    <div class="min-h-screen bg-gray-50 dark:bg-neutral-900">
      <Breadcrumb :items="[{ title: 'Hakkımızda', path: '/about' }]" />
      
      <!-- Hero Section -->
      <div class="relative h-[500px] overflow-hidden">
        <div class="absolute inset-0">
          <img src="/assets/images/about/hero.jpg" alt="Teknopark" class="w-full h-full object-cover" />
          <div class="absolute inset-0 bg-gradient-to-r from-primary/90 to-primary/40"></div>
        </div>
        <div class="relative container mx-auto px-4 h-full flex items-center">
          <div class="max-w-3xl">
            <h1 class="text-4xl md:text-6xl font-bold text-white mb-6">Geleceği Şekillendiriyoruz</h1>
            <p class="text-xl text-white/90">Teknoloji ve inovasyonun merkezi olarak, yarının çözümlerini bugünden üretiyoruz.</p>
          </div>
        </div>
      </div>
  
      <!-- Stats Section -->
      <div class="relative -mt-16 container mx-auto px-4 mb-16">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div class="bg-white dark:bg-neutral-800 rounded-2xl p-6 shadow-lg">
            <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
              <i class="fas fa-building text-primary text-2xl"></i>
            </div>
            <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2" v-motion :initial="{ opacity: 0, y: 20 }" :enter="{ opacity: 1, y: 0 }">
              250+
            </div>
            <div class="text-gray-600 dark:text-gray-400">Şirket</div>
          </div>
          <div class="bg-white dark:bg-neutral-800 rounded-2xl p-6 shadow-lg">
            <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
              <i class="fas fa-users text-primary text-2xl"></i>
            </div>
            <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2" v-motion :initial="{ opacity: 0, y: 20 }" :enter="{ opacity: 1, y: 0, delay: 100 }">
              5000+
            </div>
            <div class="text-gray-600 dark:text-gray-400">Çalışan</div>
          </div>
          <div class="bg-white dark:bg-neutral-800 rounded-2xl p-6 shadow-lg">
            <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
              <i class="fas fa-flask text-primary text-2xl"></i>
            </div>
            <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2" v-motion :initial="{ opacity: 0, y: 20 }" :enter="{ opacity: 1, y: 0, delay: 200 }">
              1000+
            </div>
            <div class="text-gray-600 dark:text-gray-400">Ar-Ge Projesi</div>
          </div>
          <div class="bg-white dark:bg-neutral-800 rounded-2xl p-6 shadow-lg">
            <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
              <i class="fas fa-award text-primary text-2xl"></i>
            </div>
            <div class="text-3xl font-bold text-gray-900 dark:text-white mb-2" v-motion :initial="{ opacity: 0, y: 20 }" :enter="{ opacity: 1, y: 0, delay: 300 }">
              100+
            </div>
            <div class="text-gray-600 dark:text-gray-400">Patent</div>
          </div>
        </div>
      </div>
  
      <!-- About Section -->
      <div class="py-16 bg-white dark:bg-neutral-800">
        <div class="container mx-auto px-4">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div class="relative">
              <div class="aspect-square rounded-2xl overflow-hidden">
                <img src="/assets/images/about/office.jpg" alt="Ofisimiz" class="w-full h-full object-cover" />
              </div>
              <div class="absolute -bottom-8 -right-8 bg-primary text-white p-8 rounded-2xl hidden lg:block">
                <div class="text-4xl font-bold mb-2">15+</div>
                <div class="text-white/90">Yıllık Deneyim</div>
              </div>
            </div>
            <div>
              <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-6">Biz Kimiz?</h2>
              <div class="prose prose-lg dark:prose-invert">
                <p>Teknopark olarak, teknoloji ve inovasyonun öncü merkezi olmayı hedefliyoruz. Türkiye'nin en büyük teknoloji geliştirme bölgelerinden biri olarak, yerli ve milli teknolojilerin geliştirilmesine öncülük ediyoruz.</p>
                <p>Ar-Ge ve inovasyon ekosistemimiz, girişimcilere ve teknoloji şirketlerine ev sahipliği yaparak, ülkemizin teknolojik dönüşümüne katkı sağlıyor.</p>
              </div>
              <div class="mt-8 space-y-4">
                <div class="flex items-center">
                  <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mr-4">
                    <i class="fas fa-check text-primary text-xl"></i>
                  </div>
                  <div class="flex-1">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Modern Altyapı</h3>
                    <p class="text-gray-600 dark:text-gray-400">Son teknoloji altyapı ve laboratuvarlar</p>
                  </div>
                </div>
                <div class="flex items-center">
                  <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mr-4">
                    <i class="fas fa-check text-primary text-xl"></i>
                  </div>
                  <div class="flex-1">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Güçlü Ekosistem</h3>
                    <p class="text-gray-600 dark:text-gray-400">Akademi ve sanayi işbirlikleri</p>
                  </div>
                </div>
                <div class="flex items-center">
                  <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mr-4">
                    <i class="fas fa-check text-primary text-xl"></i>
                  </div>
                  <div class="flex-1">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Global Vizyon</h3>
                    <p class="text-gray-600 dark:text-gray-400">Uluslararası işbirlikleri ve projeler</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Mission & Vision -->
      <div class="py-16">
        <div class="container mx-auto px-4">
          <div class="text-center mb-16">
            <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">Misyon & Vizyon</h2>
            <div class="w-24 h-1 bg-primary mx-auto rounded-full"></div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <!-- Misyon -->
            <div class="bg-white dark:bg-neutral-800 rounded-2xl p-8 shadow-lg" v-motion :initial="{ opacity: 0, x: -50 }" :enter="{ opacity: 1, x: 0 }">
              <div class="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
                <i class="fas fa-bullseye text-primary text-2xl"></i>
              </div>
              <h3 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Misyonumuz</h3>
              <p class="text-gray-600 dark:text-gray-400">Teknoloji ve inovasyon alanında öncü bir merkez olarak, ülkemizin teknolojik gelişimine katkı sağlamak ve global pazarda rekabet gücünü artırmak.</p>
            </div>
            <!-- Vizyon -->
            <div class="bg-white dark:bg-neutral-800 rounded-2xl p-8 shadow-lg" v-motion :initial="{ opacity: 0, x: 50 }" :enter="{ opacity: 1, x: 0 }">
              <div class="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
                <i class="fas fa-eye text-primary text-2xl"></i>
              </div>
              <h3 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Vizyonumuz</h3>
              <p class="text-gray-600 dark:text-gray-400">Dünya çapında tanınan bir teknoloji ve inovasyon merkezi olarak, geleceğin teknolojilerini geliştiren ve yönlendiren bir ekosistem oluşturmak.</p>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Team Section -->
      <div class="py-16 bg-white dark:bg-neutral-800">
        <div class="container mx-auto px-4">
          <div class="text-center mb-16">
            <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">Yönetim Ekibimiz</h2>
            <div class="w-24 h-1 bg-primary mx-auto rounded-full"></div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="group" v-for="(member, index) in team" :key="index" v-motion :initial="{ opacity: 0, y: 50 }" :enter="{ opacity: 1, y: 0, delay: index * 100 }">
              <div class="relative rounded-2xl overflow-hidden mb-4">
                <img :src="member.image" :alt="member.name" class="w-full aspect-[4/5] object-cover transition-transform duration-500 group-hover:scale-110" />
                <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div class="absolute bottom-4 left-4 right-4">
                    <div class="flex space-x-3">
                      <a v-for="social in member.socials" 
                         :key="social.icon" 
                         :href="social.url" 
                         class="w-8 h-8 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-primary transition-colors">
                        <i :class="social.icon"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">{{ member.name }}</h3>
              <p class="text-gray-600 dark:text-gray-400">{{ member.position }}</p>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Values Section -->
      <div class="py-16">
        <div class="container mx-auto px-4">
          <div class="text-center mb-16">
            <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">Değerlerimiz</h2>
            <div class="w-24 h-1 bg-primary mx-auto rounded-full"></div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="bg-white dark:bg-neutral-800 rounded-2xl p-8 shadow-lg" v-motion :initial="{ opacity: 0, y: 50 }" :enter="{ opacity: 1, y: 0 }">
              <div class="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
                <i class="fas fa-lightbulb text-primary text-2xl"></i>
              </div>
              <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">İnovasyon</h3>
              <p class="text-gray-600 dark:text-gray-400">Sürekli yenilik ve gelişimi destekleyerek, geleceğin teknolojilerini şekillendiriyoruz.</p>
            </div>
            <div class="bg-white dark:bg-neutral-800 rounded-2xl p-8 shadow-lg" v-motion :initial="{ opacity: 0, y: 50 }" :enter="{ opacity: 1, y: 0, delay: 100 }">
              <div class="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
                <i class="fas fa-hands-helping text-primary text-2xl"></i>
              </div>
              <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">İşbirliği</h3>
              <p class="text-gray-600 dark:text-gray-400">Akademi, sanayi ve girişimciler arasında güçlü bağlar kurarak ekosistemi büyütüyoruz.</p>
            </div>
            <div class="bg-white dark:bg-neutral-800 rounded-2xl p-8 shadow-lg" v-motion :initial="{ opacity: 0, y: 50 }" :enter="{ opacity: 1, y: 0, delay: 200 }">
              <div class="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
                <i class="fas fa-chart-line text-primary text-2xl"></i>
              </div>
              <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">Sürdürülebilirlik</h3>
              <p class="text-gray-600 dark:text-gray-400">Çevreye ve topluma duyarlı projelerle sürdürülebilir bir gelecek inşa ediyoruz.</p>
            </div>
          </div>
        </div>
      </div>
  
      <!-- CTA Section -->
      <div class="py-16 bg-primary">
        <div class="container mx-auto px-4">
          <div class="text-center">
            <h2 class="text-3xl font-bold text-white mb-6">Geleceğin Bir Parçası Olun</h2>
            <p class="text-xl text-white/90 mb-8 max-w-2xl mx-auto">Teknoloji ve inovasyon yolculuğunuzda sizinle birlikte çalışmaktan mutluluk duyarız.</p>
            <NuxtLink to="/contact" class="inline-flex items-center justify-center px-8 py-4 bg-white text-primary rounded-xl hover:bg-white/90 transition-colors group">
              <span class="font-medium">Bize Ulaşın</span>
              <i class="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  const team = [
    {
      name: 'Ahmet Yılmaz',
      position: 'Genel Müdür',
      image: 'https://t3.ftcdn.net/jpg/02/43/12/34/360_F_243123463_zTooub557xEWABDLk0jJklDyLSGl2jrr.jpg',
      socials: [
        { icon: 'fab fa-linkedin-in', url: '#' },
        { icon: 'fab fa-twitter', url: '#' }
      ]
    },
    {
      name: 'Ayşe Kaya',
      position: 'Teknoloji Direktörü',
      image: 'https://thumbs.dreamstime.com/b/closeup-up-portrait-unhappy-girl-pointing-to-herself-closeup-up-portrait-unhappy-angry-annoyed-young-woman-asking-question-159694322.jpg',
      socials: [
        { icon: 'fab fa-linkedin-in', url: '#' },
        { icon: 'fab fa-twitter', url: '#' }
      ]
    },
    {
      name: 'Mehmet Demir',
      position: 'İş Geliştirme Müdürü',
      image: 'https://media.istockphoto.com/id/661799106/photo/portrait-of-a-young-french-man.jpg?s=612x612&w=0&k=20&c=M-8ccbYQZCvQWmKLLyDF5mYjF3KaBTQwX6HDdzvw_pk=',
      socials: [
        { icon: 'fab fa-linkedin-in', url: '#' },
        { icon: 'fab fa-twitter', url: '#' }
      ]
    },
    {
      name: 'Zeynep Şahin',
      position: 'AR-GE Direktörü',
      image: 'https://t4.ftcdn.net/jpg/03/83/25/83/360_F_383258331_D8imaEMl8Q3lf7EKU2Pi78Cn0R7KkW9o.jpg',
      socials: [
        { icon: 'fab fa-linkedin-in', url: '#' },
        { icon: 'fab fa-twitter', url: '#' }
      ]
    }
  ]
  </script>